import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardComponent } from './dashboard.component';
import { DashboardResolver } from './dashboard.resolver';
import { ActivateGuard } from '../activate.guard';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivateChild: [ActivateGuard],
    resolve: {
      menu: DashboardResolver,
    },
    children: [
      {
        path: 'home',
        data: { screen: 'home' },
        loadChildren: () =>
          import('./landing/landing.module').then((m) => m.LandingModule),
      },
      {
        path: 'org-search',
        data: { screen: 'org-search' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./organization/organization.module').then(
            (m) => m.OrganizationModule
          ),
      },
      {
        path: 'inst',
        data: { screen: 'inst' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./institution/institution.module').then(
            (m) => m.InstitutionModule
          ),
      },
      {
        path: 'mdm',
        data: { screen: 'mdm' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./mdm/mdm.module').then((m) => m.MdmModule),
      },
      {
        path: 'class',
        data: { screen: 'class' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./class/class.module').then((m) => m.ClassModule),
      },
      {
        path: 'student',
        data: { screen: 'student' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./student/student.module').then((m) => m.StudentModule),
      },
      {
        path: 'org',
        data: { screen: 'org' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./org/org.module').then((m) => m.OrgModule),
      },
      {
        path: 'appuser',
        data: { screen: 'appuser' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./appuser/appuser.module').then((m) => m.AppUserModule),
      },
      {
        path: 'adminrole',
        data: { screen: 'adminrole' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./adminrole/adminrole.module').then((m) => m.AdminRoleModule),
      },
      {
        path: 'approle',
        data: { screen: 'approle' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./approle/approle.module').then((m) => m.AppRoleModule),
      },
      {
        path: 'appdl',
        data: { screen: 'appdl' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./appdl/appdl.module').then((m) => m.AppDLModule),
      },
      {
        path: 'job',
        data: { screen: 'job' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./job/job.module').then((m) => m.JobModule),
      },
      {
        path: 'doc',
        data: { screen: 'doc' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./doc/doc.module').then((m) => m.DocModule),
      },
      {
        path: 'tool',
        data: { screen: 'build' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./tool/tool.module').then((m) => m.ToolModule),
      },
      {
        path: 'cust',
        data: { screen: 'cust' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./cust/cust.module').then((m) => m.CustModule),
      },
      {
        path: 'report',
        data: { screen: 'home' },
        canActivateChild: [ActivateGuard],
        loadChildren: () =>
          import('./report/report.module').then((m) => m.ReportModule),
      },
      {
        path: 'university',
        data: { screen: 'university' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./university/university.module').then(m => m.UniversityModule),
      },
      {
        path: 'college',
        data: { screen: 'college' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./college/college.module').then(m => m.CollegeModule),
      },
      {
        path: 'course',
        data: { screen: 'course' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./course/course.module').then(m => m.CourseModule),
      },
      {
        path: 'adminusr',
        data: { screen: 'adminusr' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./adminusr/adminusr.module').then(m => m.AdminusrModule)
      },
      {
        path: 'approval',
        data: { screen: 'approval' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./approval/approval.module').then(m => m.ApprovalModule)
      },
      {
        path: 'config',
        data: { screen: 'config' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./config/config.module').then(m => m.ConfigModule)
      },
      {
        path: 'summary',
        data: { screen: 'admission-report'},
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./summary/summary.module').then(m => m.SummaryModule)
      },
      {
        path: 'notice',
        data: { screen: 'notice' },
        canActivateChild: [ActivateGuard],
        loadChildren: () => import('./notice/notice.module').then(m => m.NoticeModule)
      },
      { path: 'bot-config', data: { screen: 'bot-config' }, canActivateChild: [ActivateGuard], loadChildren: () => import('./bot-config/bot-config.module').then(m => m.BotConfigModule) },
      { path: 'incident', data: { screen: 'incident' }, canActivateChild: [ActivateGuard], loadChildren: () => import('./incident/incident.module').then(m => m.IncidentModule) },
      { path: 'service-activity', data: { screen: 'service-activity' }, canActivateChild: [ActivateGuard], loadChildren: () => import('./service-activity/service-activity.module').then(m => m.ServiceActivityModule) },
      { path: 'request', data: { screen: 'request' }, canActivateChild: [ActivateGuard], loadChildren: () => import('./request/request.module').then(m => m.RequestModule) },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: '**', redirectTo: '404', pathMatch: 'full' },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule { }
